import { render, staticRenderFns } from "./product-gallery-slot.vue?vue&type=template&id=8d096540&"
import script from "./product-gallery-slot.vue?vue&type=script&lang=js&"
export * from "./product-gallery-slot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d096540')) {
      api.createRecord('8d096540', component.options)
    } else {
      api.reload('8d096540', component.options)
    }
    module.hot.accept("./product-gallery-slot.vue?vue&type=template&id=8d096540&", function () {
      api.rerender('8d096540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product-gallery-slot/product-gallery-slot.vue"
export default component.exports